// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"b19c24c3fe678a5f5eed","532":"ca0e03065ca566e79e81","691":"51373681f0066e2c34af"}[chunkId] + ".js";
};